var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10H12.5M10 12.5V7.5",
    stroke: "#36D66B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8384 2.78515C7.10492 2.05243 8.5427 1.66768 10.0059 1.66993C14.6093 1.66993 18.3409 5.40151 18.3409 10.0049C18.3409 14.6083 14.6093 18.3399 10.0059 18.3399C5.40248 18.3399 1.6709 14.6083 1.6709 10.0049C1.6709 8.48712 2.07681 7.06267 2.78612 5.83743",
    stroke: "#36D66B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.0615d73c194d82b66e5c44ad9bf49138.svg";
export { ForwardRef as ReactComponent };